<template>
  <Modal v-bind="$attrs" @cancel="emits('cancel')" @confirm="onConfirm">
    <CreativeFormPreview :max-count="maxCount" :groups="creativeGroups">
      <template #checkbox="{ item, index }">
        <el-checkbox v-model="item.isCheck" @change="onCheckStateChange($event, index)"> </el-checkbox>
        <span>&ensp;</span>
      </template>
    </CreativeFormPreview>
  </Modal>
</template>

<script setup>
import { ref } from 'vue'
import { Message } from 'view-design'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import CreativeFormPreview from '@/views/create/bytedance/components/creative/components/creative-preview/smallView.vue'
// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  creativeList: Array,
  maxCount: Number
})
const creativeGroups = ref(props.creativeList)
function onCheckStateChange(val, index) {
  creativeGroups.value = creativeGroups.value.map((c, _index) => {
    if (val) {
      return { ...c, isCheck: _index === index }
    }
    return { ...c, isCheck: false }
  })
}

function onConfirm() {
  const checkedItem = creativeGroups.value.find((c) => c.isCheck)
  if (checkedItem) {
    emits('confirm', checkedItem)
  } else {
    Message.error('请选择一个创意组')
  }
}
</script>

<style lang="scss" scoped></style>
